// This file is generated by scripts/generate-resource-reading-times.js.
// Run npm run reading-times after changing guide content.
export const resourceReadingTimes: Record<string, string> = {
  "how-to-prepare-for-your-family-photo-session": "4 min read",
  "best-time-of-day-for-family-photos": "3 min read",
  "what-to-wear-for-family-photos": "2 min read",
  "how-to-prepare-kids-for-family-photos": "3 min read",
  "what-is-the-best-age-for-baby-photos": "3 min read",
  "what-happens-during-a-baby-photography-session": "3 min read",
  "how-to-prepare-for-your-baby-photo-session": "3 min read",
  "when-is-the-best-time-to-take-maternity-photos": "4 min read",
  "what-to-wear-for-maternity-photos": "3 min read",
  "how-to-prepare-for-your-maternity-photo-session": "3 min read",
  "best-age-for-newborn-photos": "4 min read",
  "what-happens-during-a-newborn-session": "5 min read",
  "how-to-prepare-for-your-newborn-session": "5 min read",
  "newborn-photography-safety": "4 min read",
  "in-home-newborn-photography": "5 min read"
};
